// @flow

import { h } from 'preact';
import { connect } from 'unistore/full/preact';

import Button from 'preact-material-components/Button';
import 'preact-material-components/Button/style.css';
import 'preact-material-components/Theme/style.css';

import { route } from 'preact-router';

import PureComponent from './PureComponent';

import style from './AppBar.css';

import GoogleLogout from './GoogleLogout';
import type { Student } from '../routes/StudentListPage';
import { Pages, Modes } from './appConstants';

const AppBar = () => (
  <header className={style.appbar}>
    <div className={style.toolbar}>
      <span className={style.toolbarText}>Choir Attendance</span>

      <span className={style.toolbarSpacer} />

      <SettingsButton />

      <LogoutButton />
    </div>
  </header>
);

@connect('accountMode')
class SettingsButton extends PureComponent {
  handleSettings = () => {
    route(Pages.Admin);
  };

  render() {
    return this.props.accountMode === Modes.Admin ? (
      <Button
        className={style.toolbarButton}
        outlined={true}
        onClick={this.handleSettings}
      >
        Admin Settings
      </Button>
    ) : null;
  }
}

type SendButtonProps = {
  students: { string: Student }
};
const actions = store => ({
  handleLogoutSuccess(state) {
    store.setState({
      accessToken: '',
      accountMode: Modes.SignedOut,
      profile: {},
      event: ''
    });

    route(Pages.Login, true);
  }
});
@connect(
  'accountMode',
  actions
)
class LogoutButton extends PureComponent<SendButtonProps> {
  render() {
    return this.props.accountMode !== Modes.SignedOut ? (
      <div>
        <GoogleLogout
          className={style['mdc-icon-toggle']}
          onLogoutSuccess={this.props.handleLogoutSuccess}
        />
      </div>
    ) : null;
  }
}

export default AppBar;



// WEBPACK FOOTER //
// ./components/AppBar.js